import React from 'react';
import { CountryProvider } from 'common/src/contexts/CountryContext';

const AppProviders = ({ children }) => (
  <CountryProvider>{children}</CountryProvider>
);

export default AppProviders;
